import React from 'react'
import {loadStripe} from '@stripe/stripe-js';
import { apiCall, secondaryApi } from "./ApiUtils";
import { auditCaseStudyMetrics } from './Audits';
import setting from './Settings';

import army from '../../assets/images/army.png'
import airForce from '../../assets/images/air-force.png'
import coastGuard from '../../assets/images/coast-guard.png'
import navy from '../../assets/images/navy.png'
import marines from '../../assets/images/marines.png'
import spouse from '../../assets/images/spouse.png'

import bingIcon from '../../assets/images/ms-ads.png'
import duckDuckGoIcon from '../../assets/images/duckduckgo.png' 
import smsIcon from '../../assets/images/sms.png' 

import googleAnalytics from '../../assets/images/ic_analytics.png'
import gmbImg from '../../assets/images/big-gmb.png'
import fbImg from '../../assets/images/fb-megaphone.png'
import fbInsightsImg from '../../assets/images/facebook-logo.png'
import msAds from '../../assets/images/ms-ads.png'
import linkedInImg from '../../assets/images/linkedin.png'
import linkedInAdsImg from '../../assets/images/linkedin-ads.png'
import pageSpeedInsightsImg from '../../assets/images/pagespeed-insights.png'
import googleAdsImg from '../../assets/images/g-ads.png'
import gscImg from '../../assets/images/search_console.png'

import GoogleAnalyticsComp from '../components/Admin/ServiceTypes/GoogleAnalytics';
import LinkedInOrg from '../components/Admin/ServiceTypes/LinkedInOrg';
import GoogleMyBusinessComp from '../components/Admin/ServiceTypes/GoogleMyBusiness';
import MicrosoftAds from '../components/Admin/ServiceTypes/MicrosoftAds';
import FacebookAds from '../components/Admin/ServiceTypes/FacebookAds';
import LinkedInAds from '../components/Admin/ServiceTypes/LinkedInAds';
import FacebookInsights from '../components/Admin/ServiceTypes/FacebookInsights';
import GoogleSearchConsole from '../components/Admin/ServiceTypes/GoogleSearchConsole';
import ISLVQuestions from '../components/Onboarding/Steps/QuestionPages/ISL-V';

export const MILITARY_DICTIONARY = {
    army,
    airForce,
    coastGuard,
    navy,
    marines,
    spouse
}

export const WS_URL = "wss://cron.internetstrategylabs.com:9002/mqtt"

const { VITE_STRIPE_PUBLISH_KEY } = import.meta.env
export const SESSION_CLEAR_DISABLED = ["siteTheme"]

export const DEFAULT_GOOGLE_CLIENT_ID = "1095314294745-k5j46k1dnuvt79ovqe080nv388dhfle1.apps.googleusercontent.com"

export const stripePromise = loadStripe(VITE_STRIPE_PUBLISH_KEY);

export const ROAS_THRESHOLD=1.5

export const DEFAULT_COMPRESSION_LEVEL = 4

export const MAIN_SUBSCRIPTION_TYPE = "main_subscription"

export const allowedSiteTypes = ["TOP_ORG", "ORG", "TOKEN"]

export function strip(html){
    let doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || "";
 }

export const OVERRIDE_ID_GA = "overrideAccountga"
export const OVERRIDE_ID_GMB = "overrideAccountgmb"
export const OVERRIDE_ID_FB = "overrideAccountfb"
export const OVERRIDE_ID_FB_PAGE = "overrideAccountfbPage"
export const OVERRIDE_ID_LINKEDIN = "overrideAccountlinkedin"
export const OVERRIDE_ID_LINKEDIN_ORG = "overrideAccountlinkedinOrg"
export const OVERRIDE_ID_BING = "overrideAccountbing"
export const OVERRIDE_ID_GSC = "overrideAccountgsc"
export const OVERRIDE_ID_UA_TO_GA4 = "overrideAccountga4"

export const DATATABLE_DEFAULT_OPTIONS = {
    dom: 'Bfrtip',
    scrollY: 350,
    scrollX: 'auto',
    order: [[ 1, 'desc' ]],
    extend: 'pdfHtml5',
    buttons: [ 'copy', 'csv', 'print', 'excel', 'pdf' ],
    responsive: true,
    info: false,
    paging: false,
    searching: false,
    scrollCollapse: true,
    orderCellsTop: true,
    destroy: true,
    autoWidth: false
}

export const LOCATION_NAME_MAP = {
    "/overview": "Overview",
    "/quick-stats": "Quick Stats",
    "/insights": "Insights & Recommendations",
    "/ads-ecommerce": "E-commerce",
    "/email-activity": "Email Activity",
    "/task-manager": "Task Management",
    "/site-performance": "Site Performance",
    "/pagespeed": "PageSpeed Insights",
    "/channel-performance": "Channel Performance",
    "/ads-paid": "Paid Campaigns",
    "/goals": "Goals, Events, and Conversions",
    "/report-monthly": "Monthly Report",
    "/report-annual": "Annual Report",
    "/unit-sales": "Unit Sales Module",
    "/report-revenue": "Revenue & Sales Performance",
    "/audits": "Audits",
    "/score-card": "Score Card Report",
    "/summaries-company": "Company Summary",
    "/summaries-brand": "Brand Summary",
    "/summaries-group": "Organization Summary",
    "/admin": "Site Management",
    "/unit-sales-entry": "Unit Sales Entry",
    "/revenue-entry": "Revenue Entry",
    "/settings": "User Settings",
    "/billing-management": "Billing Management",
    "/admin-organizations": "Organization Management",
    "/admin-site-upload": "Admin Site Upload",
    "/help": "Help Center"
}

export const THEME_DEFAULT = {
    "origin": "https://engine.internetstrategylabs.com",
    "favIcon": "https://engine.internetstrategylabs.com/images/insights-engine-icon.png",
    "emailLogo": "https://engine.internetstrategylabs.com/images/engine-animate.gif",
    "secondaryColorHex": "#239ad4",
    "sideMenuColorHex": "#284699",
    "emailBanner": "https://engine.internetstrategylabs.com/images/insights-engine.png",
    "primaryColorHex": "#284699",
    "title": "Insights Engine",
    "mainLogo": "https://engine.internetstrategylabs.com/images/insights-engine.png",
    "integrations": {
        "google": {
            "clientId": "993100380805-17p9f47ah432g9vt3c77beidn5cfbst2.apps.googleusercontent.com"
        }
    },
    "attr": {
     "hasEcommerce": true
    },
    "email": "support@internetstrategylabs.com"
}

export const socialChannels = {
    Facebook: ['facebook'],
    Glassdoor: ['glassdoor'],
    YouTube: ['youtube'],
    Twitter: ['twitter'],
    LinkedIn: ['linkedin'],
    Instagram: ['instagram'],
    Pocket: ['pocket'],
    Pinterest: ['pinterest'],
    'Google+': ['plus\\.google\\.com'],
    Yelp: ['yelp'],
    Blogger: ['blogger'],
    Naver: ['naver'],
    TripAdvisor: ['tripadvisor'],
    FourSquare: ['foursquare'],
    Reddit: ['reddit'],
    Epicurious: ['epicurious'],
    Tiktok:['tiktok']
}

export const aiAssistants = [
    "chatgpt.com",
    "claude.ai",
    "gemini"
]

export const NOTIFICATION_TYPE_MAP = {
    ALERT: "danger",
    AUDIT: "success"
}

export const isTypedArray = (arg) => {
    const TypedArray = Object.getPrototypeOf(Uint8Array)
    return arg instanceof TypedArray;
}

export const convertFromBinary = (type = "image/png", binary) => {
    return `data:${type};base64,${binary}`
}

export const formatDuration = (a, b) => `${Math.floor(a/b/60)}:${("0"+Math.round(a/b-60*Math.floor(a/b/60))).slice(-2)}`

export const formatAverage = (a, b, exclude=false) => {
    if(a === 0 || b === 0){
        return 0
    }
    if(exclude){
      return Math.round(100*a/b)/100
    }
    return `${Math.round(100*a/b)/100}`.replace(/(\.\d)$/, '$10')
}

export const roundValue = (a, decimaPoints= 0) => {
    let rounder = decimaPoints === 0 ? 1 : Math.pow(10, decimaPoints)
    return `${Math.round(rounder*a/rounder)}`.replace(/(\.\d)$/, `$10`)
} 

export const formatPercent = (a, b, exclude=false) => {
    if(a === 0 || b === 0){
        return 0
    }
    if(exclude){
      return Math.round(100*a/b)
    }
    return `${Math.round(100*a/b)}%`
}

export const toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
});

export const generatePassword = (length = 8) => {
    let charset = "ABCDEFGHIJKLMNOPQRSTUVWXYZ", 
        retVal = ""
        
    let n = charset.length
    retVal += charset.charAt(Math.floor(Math.random() * n));
    for (var i = 0; i < length - 1; ++i) {
        if(i % 2 == 0){
            charset = "abcdefghijklmnopqrstuvwxyz"
        } else if(i % 3 == 0){
            charset = "0123456789"
        }else{
            charset = "!#$&%"
        }
        n = charset.length
        retVal += charset.charAt(Math.floor(Math.random() * n));
    }
    return retVal;
}

export function randomIntFromInterval(min, max) { // min and max included 
    return Math.floor(Math.random() * (max - min + 1) + min)
}

export const getToken = () => localStorage.getItem("token")

export const getImageSpecs = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e) => {
        let image = new Image();
        
        //Set the Base64 string return from FileReader as source.
        image.src = e.target.result;
        
        //Validate the File Height and Width.
        image.onload = () => {
            let height = image.height;
            let width = image.width;
            resolve({
                height,
                width,
                filesize: file.size
            })
        };
    }
    reader.onerror = error => reject(error);
})

export function createMarkup(str) {
    return {__html: str};
}

export const capitalize = (s) => {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
}

export const generateAuthLink = (token, exp, origin) => {
    return `${origin}?id_token=${token}&expires_in=${exp}&token_type=token`
}

export const alertIconPath = "/images/alert-icons/"

export const iconDictionaryByMed = {
    "google": <a href="javascript:;" class="btn btn-social btn-xs btn-google"><i class="fab fa-google"></i>&nbsp;&nbsp;&nbsp;</a>,
    "facebook": <a href="javascript:;" class="btn btn-social btn-xs btn-facebook"><i class="fab fa-facebook"></i>&nbsp;&nbsp;&nbsp;</a>,
    "instagram": <a href="javascript:;" class="btn btn-social-icon btn-xs btn-default">
        <i class="fab fa-instagram" style={{
            background: "radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%, #d6249f 60%, #285AEB 90%)",
            webkitTextFillColor: "transparent",
            backgroundClip: "text",
        }}></i>&nbsp;&nbsp;&nbsp;</a>,
    "yahoo":  <a href="javascript:;" class="btn btn-social btn-xs btn-yahoo"><i class="fab fa-yahoo"></i>&nbsp;&nbsp;&nbsp;</a>,
    "bing": <img src={bingIcon} style={{paddingLeft: 0, width: "24px"}} />,
    "duckduckgo": <img src={duckDuckGoIcon} style={{paddingLeft: 0, width: "24px"}} />,
    "email": <i class="fas fa-envelope fa-1-5 text-warning" style={{paddingLeft: 0, width: "24px"}} />,
    "paypal": <a href="javascript:;" class="btn btn-social btn-xs btn-vimeo"><i class="fab fa-paypal"></i>&nbsp;&nbsp;&nbsp;</a>,
    "text": <img src={smsIcon} style={{paddingLeft: 0, width: "24px"}} />,
    "youtube": <a href="javascript:;" class="btn btn-social btn-xs btn-default"><i class="fab fa-youtube-square text-danger"></i>&nbsp;&nbsp;&nbsp;</a>,
    "reddit": <a href="javascript:;" class="btn btn-social btn-xs btn-default"><i class="fab fa-reddit-square text-orange"></i>&nbsp;&nbsp;&nbsp;</a>,
    "pinterest": <a href="javascript:;" class="btn btn-social btn-xs btn-pinterest"><i class="fab fa-pinterest"></i>&nbsp;&nbsp;&nbsp;</a>,
    "linkedin": <a href="javascript:;" class="btn btn-social btn-xs btn-linkedin"><i class="fab fa-linkedin"></i>&nbsp;&nbsp;&nbsp;</a>,
}

export const getTheme = (origin) => apiCall(`theme?origin=${origin}`, {
    method: 'GET'
}, null, secondaryApi)

export const setTheme = (theme) => sessionStorage.setItem("siteTheme", JSON.stringify(theme))

export const parseTheme = () => sessionStorage.getItem("siteTheme") ? JSON.parse(sessionStorage.getItem("siteTheme")) : null

export const clearSessionStorage = () => {
    const session = {}
    SESSION_CLEAR_DISABLED.forEach(k => session[k] = sessionStorage.getItem(k))
    
    sessionStorage.clear()

    Object.keys(session).forEach(k => sessionStorage.setItem(k, session[k]))
}

export const headerTableColumnStyle = function (firstColumn){
    let style = {}
    if(!firstColumn){
        style['text-right'] = true
    }
    if(setting.useAltStyle){
        style['text-white'] = true
    }
    return style
}

export const headerTableRowStyle = {
    h4: true,
    'semi-bold':true,
    'bg-info': true
}

export const serviceMap = {
    ga: {
        key: "ga",
        title: <>Google <br />Analytics</>,
        titleUnformatted: "Google Analytics",
        img: googleAnalytics,
        component: GoogleAnalyticsComp,
        popular: true
    },
    gmb: {
        key: "gmb",
        title: <>Google Business <br /> Profile</>,
        titleUnformatted: "Google Business Profile",
        img: gmbImg,
        component: GoogleMyBusinessComp,
        popular: true
    },
    fbPage: {
        key: "fbPage",
        title: <>Facebook<br /> Insights</>,
        titleUnformatted: "Facebook Insights",
        component: FacebookInsights,
        img: fbInsightsImg
    },
    linkedinOrg: {
        key: "linkedinOrg",
        title: <>LinkedIn<br /> Organization</>,
        titleUnformatted: "LinkedIn Organization",
        component: LinkedInOrg,
        img: linkedInImg
    },
    bing: {
        key: "bing",
        title: <>Microsoft<br /> Ads</>,
        titleUnformatted: "Microsoft Ads",
        component: MicrosoftAds,
        img: msAds
    },
    fb: {
        key: "fb",
        title: <>Facebook<br /> Ads</>,
        titleUnformatted: "Facebook Ads",
        img: fbImg,
        component: FacebookAds,
        popular: true
    },
    linkedin: {
        key: "linkedin",
        title: <>LinkedIn<br /> Ads</>,
        titleUnformatted: "LinkedIn Ads",
        component: LinkedInAds,
        img: linkedInAdsImg
    },
    gsc: {
        key: "gsc",
        title: <>Google Search<br /> Console</>,
        titleUnformatted: "Google Search Console",
        component: GoogleSearchConsole,
        img: gscImg
    }
}

export const defaultServiceMap = {
    googleAds: {
        key: "googleAds",
        title: <>Google Ads</>,
        titleUnformatted: "Google Ads",
        img: googleAdsImg
    },
    googlePage: {
        key: "googlePage",
        title: <>Google Page<br /> Speed Insight</>,
        titleUnformatted: "Google Page Speed Insight",
        img: pageSpeedInsightsImg
    }
}

export const oauthConsts = () =>  {
    const theme = parseTheme()
    return {
        gaAuthURL: (useGA4) => 'https://accounts.google.com/o/oauth2/v2/auth?scope='
        +encodeURIComponent('https://www.googleapis.com/auth/analytics.readonly openid email')
        +'&access_type=offline&include_granted_scopes=true&prompt=consent&redirect_uri='
        +encodeURIComponent((window.location.hostname==='localhost' ?
                'http://localhost' + ':' + window.location.port :  'https://' + window.location.hostname) + '/api/boarding' + (`${window.location.hostname==='localhost' ? '?environment=development' : '?environment=' + window.location.hostname.replace(/(^app\.|^staging\.|^engine\.)/,'').split('.').slice(0,-1).join('.') + (window.location.hostname.includes('staging.') ? '&prefix=staging' : '')}`) + (useGA4 ? "&ga_type=GA4" : ""))
        +'&response_type=code&client_id=' + (theme?.integrations?.google?.clientId ?? DEFAULT_GOOGLE_CLIENT_ID),
        gmbAuthURL: 'https://accounts.google.com/o/oauth2/v2/auth?scope='
        +encodeURIComponent('https://www.googleapis.com/auth/business.manage openid email')
        +'&access_type=offline&include_granted_scopes=true&prompt=consent&redirect_uri='
        +encodeURIComponent((window.location.hostname==='localhost' ?
                'http://localhost' + ':' + window.location.port :  'https://' + window.location.hostname) + '/api/boarding' + (`${window.location.hostname==='localhost' ? '?environment=development&token_origin=gmb' : ('?environment=' + window.location.hostname.replace(/^app\.|^staging\.|^engine\./,'').split('.').slice(0,-1).join('.') ) + '&token_origin=gmb' + (window.location.hostname.includes('staging.') ? '&prefix=staging':'')}`))
        +'&response_type=code&client_id=' + (theme?.integrations?.google?.clientId ?? DEFAULT_GOOGLE_CLIENT_ID) +'',
        fbAuthURL: 'https://www.facebook.com/v3.3/dialog/oauth?redirect_uri='
        + encodeURIComponent((window.location.hostname==='localhost' ? 'http://localhost' + ':' + window.location.port : 'https://' + window.location.hostname) + '/api/fbboarding' + (`${window.location.hostname==='localhost' ? '?environment=development' : window.location.hostname.includes('staging.') ? ('?environment=' + window.location.hostname.replace(/^app\.|^staging\.|^engine\./,'').split('.').slice(0,-1).join('.')) + "&prefix=staging" : ''}`)) 
        + `&client_id=${import.meta.env.MODE === 'development' ? 874192083417638 : 603646323393821}&scope=ads_read,leads_retrieval,pages_manage_ads&response_type=code&return_scopes=true`,
        fbPageAuthURL: 'https://www.facebook.com/v3.3/dialog/oauth?redirect_uri='
        + encodeURIComponent((window.location.hostname==='localhost' ? 'http://localhost' + ':' + window.location.port : 'https://' + window.location.hostname) + '/api/fbboarding' + (`${window.location.hostname==='localhost' ? '?environment=development&pages=1' : window.location.hostname.includes('staging.') ? ('?environment=' + window.location.hostname.replace(/^app\.|^staging\.|^engine\./,'').split('.').slice(0,-1).join('.')) + '&prefix=staging&pages=1' : '?pages=1'}`)) 
        + `&client_id=${import.meta.env.MODE === 'development' ? 874192083417638 : 603646323393821}&scope=ads_read,public_profile,read_insights,pages_show_list,pages_read_engagement,instagram_basic,instagram_manage_insights,leads_retrieval,pages_manage_ads&response_type=code&return_scopes=true`,
        bingAdsAuthURL: 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize?' +
        'client_id=a0207c43-3607-479c-b656-7fc3aaf0ed06&response_type=code' +
        '&redirect_uri=' + encodeURIComponent((secondaryApi) + '/boarding/bing'+(window.location.hostname.includes('staging.') ? '/stage' : '')) +
        '&response_mode=form_post&scope=openid%20offline_access%20https%3A%2F%2Fads.microsoft.com%2Fmsads.manage&nonce=7362CAEA-9CA5-4B43-9BA3-34D7C303EBA7',
        linkedInAuthURL: 'https://www.linkedin.com/oauth/v2/authorization?client_id=78o7ew34t0jw9r&response_type=code&redirect_uri='+ (secondaryApi ) +'/boarding/linkedin'+(window.location.hostname.includes('staging.') ?'?environment=stage' : '') + '&scope=r_basicprofile%20r_ads_reporting%20r_ads%20r_organization_social%20rw_organization_admin',
        linkedInOrgAuthURL: 'https://www.linkedin.com/oauth/v2/authorization?client_id=78o7ew34t0jw9r&response_type=code&redirect_uri='+ (secondaryApi ) +'/boarding/linkedinOrg'+(window.location.hostname.includes('staging.') ?'?environment=stage' : '') + '&scope=r_basicprofile%20r_ads_reporting%20r_ads%20r_organization_social%20rw_organization_admin',
        gscAuthURL: 'https://accounts.google.com/o/oauth2/v2/auth?scope='
        +encodeURIComponent('https://www.googleapis.com/auth/webmasters.readonly openid email')
        +'&access_type=offline&include_granted_scopes=true&prompt=consent&redirect_uri='
        +encodeURIComponent((window.location.hostname==='localhost' ?
                'http://localhost' + ':' + window.location.port :  'https://' + window.location.hostname) + '/api/boarding' + (`${window.location.hostname==='localhost' ? '?environment=development&token_origin=gsc' : ('?environment=' + window.location.hostname.replace(/^app\.|^staging\.|^engine\./,'').split('.').slice(0,-1).join('.') ) + '&token_origin=gsc' + (window.location.hostname.includes('staging.') ? '&prefix=staging':'')}`))
        +'&response_type=code&client_id=' + (theme?.integrations?.google?.clientId ?? DEFAULT_GOOGLE_CLIENT_ID) +'',
    }
}

export const getVersion = () => apiCall(`version`, {
    mthod: "GET"
}, null, secondaryApi)

export const revenueRadialGraph = {
    series: [0],
    options: {
        chart: {
            height: 150,
            width: 175,
            type: 'radialBar'
        },
        plotOptions: {
            radialBar: {
                startAngle: -90,
                endAngle: 90,
                track: {
                    background: "#e7e7e7",
                    strokeWidth: '97%',
                    margin: 5, // margin is in pixels
                    dropShadow: {
                        enabled: true,
                        top: 2,
                        left: 0,
                        color: '#999',
                        opacity: 1,
                        blur: 2
                    }
                },
                dataLabels: {
                    name: {
                        fontSize: '12px',
                        color: "#000",
                        offsetY: 40,
                        fontWeight: 400
                    },
                    value: {
                        offsetY: 10,
                        fontWeight: 'bold',
                        fontSize: '26px',
                        color: "#000",
                        formatter: function (val) {
                            return val + "%";
                        }
                    }
                }
            }
        },
        grid: {
            padding: {
              top: -10
            }
        },
        fill: {
            colors: ["#25E427"]
        },
        labels: ['of Total Revenue'],
        responsive: [
            {
                breakpoint: 570,
                options: {
                  chart: {
                      height: 150,
                      width: 175
                  },
                  plotOptions: {
                      radialBar: {
                          dataLabels: {
                              name: {
                                  fontSize: '10px',
                                  color: "#000",
                                  offsetY: 40,
                                  fontWeight: 400
                              },
                              value: {
                                  offsetY: 10,
                                  fontWeight: 'bold',
                                  fontSize: '26px',
                                  color: "#000",
                                  formatter: function (val) {
                                      return val + "%";
                                  }
                              }
                          }
                      }
                  },
                }
            }, {
              breakpoint: 675,
              options: {
                chart: {
                    height: 100,
                    width: 100
                },
                plotOptions: {
                    radialBar: {
                        dataLabels: {
                            name: {
                                fontSize: '10px',
                                color: "#000",
                                offsetY: 40,
                                fontWeight: 400
                            },
                            value: {
                                offsetY: 10,
                                fontWeight: 'bold',
                                fontSize: '16px',
                                color: "#000",
                                formatter: function (val) {
                                    return val + "%";
                                }
                            }
                        }
                    }
                },
              }
            }, {
              breakpoint: 767,
              options: {
                chart: {
                    height: 150,
                    width: 175
                },
                plotOptions: {
                    radialBar: {
                        dataLabels: {
                            name: {
                                fontSize: '10px',
                                color: "#000",
                                offsetY: 40,
                                fontWeight: 400
                            },
                            value: {
                                offsetY: 10,
                                fontWeight: 'bold',
                                fontSize: '26px',
                                color: "#000",
                                formatter: function (val) {
                                    return val + "%";
                                }
                            }
                        }
                    }
                },
              }
            }, {
              breakpoint: 890,
              options: {
                chart: {
                    height: 100,
                    width: 100
                },
                plotOptions: {
                    radialBar: {
                        dataLabels: {
                            name: {
                                fontSize: '10px',
                                color: "#000",
                                offsetY: 40,
                                fontWeight: 400
                            },
                            value: {
                                offsetY: 10,
                                fontWeight: 'bold',
                                fontSize: '16px',
                                color: "#000",
                                formatter: function (val) {
                                    return val + "%";
                                }
                            }
                        }
                    }
                },
              }
            }, {
              breakpoint: 1199,
              options: {
                chart: {
                    height: 150,
                    width: 175
                },
                plotOptions: {
                    radialBar: {
                        dataLabels: {
                            name: {
                                fontSize: '10px',
                                color: "#000",
                                offsetY: 40,
                                fontWeight: 400
                            },
                            value: {
                                offsetY: 10,
                                fontWeight: 'bold',
                                fontSize: '22px',
                                color: "#000",
                                formatter: function (val) {
                                    return val + "%";
                                }
                            }
                        }
                    }
                },
              }
            }, {
              breakpoint: 1450,
              options: {
                chart: {
                    height: 100,
                    width: 100
                },
                plotOptions: {
                    radialBar: {
                        dataLabels: {
                            name: {
                                fontSize: '10px',
                                color: "#000",
                                offsetY: 40,
                                fontWeight: 400
                            },
                            value: {
                                offsetY: 10,
                                fontWeight: 'bold',
                                fontSize: '16px',
                                color: "#000",
                                formatter: function (val) {
                                    return val + "%";
                                }
                            }
                        }
                    }
                },
              }
            }, 
            {
              breakpoint: 2000,
              options: {
                chart: {
                    height: 150,
                    width: 175
                }
              }
            }
        ]
    }
}

export const polarAreaGraph = {
    type: "polarArea", 
    dropShadow:{
        enabled: true,
        blur: 1,
        left: 1,
        top: 1
    },                  
    height:450,
    width:300,
    options: {   
        stroke: {
            colors: ["#fff"]
        },
        responsive: [{
            breakpoint: 1300,
            options: {
                chart: {
                    width: 200,
                    height: 350
                }
            }
        }, {
            breakpoint: 1199,
            options: {
                chart: {
                    width: 350,
                    height: 300
                }
            }
        }, {
            breakpoint: 960,
            options: {
                chart: {
                    width: 250,
                    height: 300
                }
            }
        }, {
            breakpoint: 767,
            options: {
                chart: {
                    width: 400,
                    height: 300
                }
            }
        }, {
            breakpoint: 575,
            options: {
                chart: {
                    width: 250,
                    height: 300
                }
            }
        }], 
    }
}

export const funnelChart = {
    series: [
        {
          name: "",
          data: [],
        },
    ],
    options: {
        chart: {
            type: 'bar',
            height: 350,
        },
        plotOptions: {
            bar: {
                borderRadius: 0,
                horizontal: true,
                barHeight: '80%',
                distributed: true,
                isFunnel: true,
            },
        },
        colors: [
            '#3c8ec3',
            '#45ba9e',
            '#73d993',
            '#44bb69'
        ],
        dataLabels: {
            enabled: true,
            formatter: function (val, opt) {
                return opt.w.globals.labels[opt.dataPointIndex] + ':  ' + val
            },
            dropShadow: {
                enabled: true,
            },
        },
        title: {
            text: 'Sales Funnel',
            align: 'middle',
        },
        xaxis: {
            categories: [
                'Booked',
                'Applications Signed',
                'Discovery Day',
                'Deals'
            ],
        },
        legend: {
            show: false,
        },
    },
}

export const pieChart = {
    series: [
        
    ],
    options: {
        chart: {
            type: 'pie',
            legend: {
                position: "top",
              },
        },
        colors: [],
        legend: {
          position: "top",
        },
        dataLabels: {
            enabled: true,
            dropShadow: {
                enabled: true,
            },
        },
        labels: [],
        responsive: [
            {
              breakpoint: 1900,
              options: {
                chart: {
                  width: 350
                },
                legend: {
                  position: "top"
                }
              }
            },
            {
              breakpoint: 1500,
              options: {
                chart: {
                  width: 300
                },
                legend: {
                    position: "top"
                }
              }
            },
            {
              breakpoint: 1200,
              options: {
                chart: {
                  width: 250
                },
                legend: {
                    position: "top"
                }
              }
            },
            {
              breakpoint: 1000,
              options: {
                chart: {
                  width: 200
                },
                legend: {
                    position: "top"
                }
              }
            },
            {
              breakpoint: 991,
              options: {
                chart: {
                  width: 350
                },
                legend: {
                    position: "top"
                }
              }
            }
        ]
    }
}

export function isQuotaExceededError(err) {
    return (
      err instanceof DOMException &&
      // everything except Firefox
      (err.code === 22 ||
        // Firefox
        err.code === 1014 ||
        // test name field too, because code might not be present
        // everything except Firefox
        err.name === "QuotaExceededError" ||
        // Firefox
        err.name === "NS_ERROR_DOM_QUOTA_REACHED")
    );
}

export const combineObjects = (oldObj, newObj, templObj=null) => {
    Object.keys(newObj).forEach(key => {
        if(typeof newObj[key] === "number"){
            if(oldObj[key] === undefined){
                oldObj[key] = 0
            }

            oldObj[key] += newObj[key]
        } else if(Array.isArray(newObj[key])){
            if(oldObj[key] === undefined){
                oldObj[key] = []
            }
            oldObj[key].push(...newObj[key])
        } else if(typeof newObj[key] === "object"){
            if(oldObj[key] === undefined){
                oldObj[key] = {}
            }
            oldObj[key] = combineObjects(oldObj[key], newObj[key])
        }

    })
    return oldObj
}

export const vetfranCheckListValue = {
    logo: 5,
    category: 5,
    veteranBenefit: 10,
    businessDesc: 20,
    imgCarousel: 10,
    videoEmbed: 10,
    startupCost: 10,
    investment: 10,
    webTrackingUrl: 10,
    veteranParticipation: 10
}

export const SITE_TOKEN_ONBOARDING_QUESTIONS = {
    ["ISL-V"]: {
        component: ISLVQuestions,
        questions: [
            "What CRM do you use, if any?",
            "Do you use either SMS appointment booking like Calendly or an AI driven appointment booking solution? If so, what platform?",
            "Do you have last year's unit sales & revenue for import into the Insights Engine?",
            "Do you have a budget for this years unit sales & revenue for import into the Insights Engine?",
            "Would you like our platform to provide a top ten keyword score for your free trial?",
            "Are you a member of any veteran specific organizations that you love?",
            "Are you interested in bi-monthly peer group calls with like minded veterans on all topics related to website and campaign performance?"
        ]
    }
}

export function debounce(func, timeout = 300){
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
}

export const DIRECTORY_CATEGORIES = {
    health: "Health",
    foodBeverages: "Foods and Beverages",
    fitness: "Fitness",
    apparel: "Apparel",
    toysHobbies: "Toys & Hobbies",
    sports: "Sports",
    baby: "Baby",
    electronics: "Electronics",
    other: "Other"
}

export const SITE_DICTIONARY = {
    SITE: "Site",
    REG: "Region",
    TOP_ORG: "Organization",
    TOKEN: "Agency",
    ORG: "Company"
}

export const numberFormatter = new Intl.NumberFormat('en', { notation: 'compact', style: 'currency', currency: 'USD' })

export function findMedian(arr) {
    if(!arr || arr.length === 0) return 0;
    arr.sort((a, b) => a - b);
    const middleIndex = Math.floor(arr.length / 2);

    if (arr.length % 2 === 0) {
        return (arr[middleIndex - 1] + arr[middleIndex]) / 2;
    } else {
        return arr[middleIndex];
    }
}

export const BUSINESS_CATEGORIES = [
    "Advertising & Marketing",
    "Automotive",
    "Beverages",
    "Business Services",
    "Children's Services",
    "Cleaning and Maintenance",
    "Commercial and Residential Services",
    "Computers & Technology",
    "Construction",
    "Consultants & Business Brokers",
    "Education",
    "Education, Training & Resources",
    "Employment & Staffing",
    "Entertainment & Event Planning",
    "Financial Services",
    "Fitness",
    "Food & Restaurants",
    "Healthcare",
    "Home Services and Repair",
    "Lodging",
    "Moving and Storage",
    "Personal Care and Wellness",
    "Personal Services",
    "Pet Services",
    "Photography & Video",
    "Printing, Copying, Shipping & Signs",
    "Quick Service Restaurants",
    "Real Estate",
    "Restoration & Disaster Recovery",
    "Retail Services",
    "Senior Care",
    "Sports & Recreation",
    "Table/Full Service Restaurants",
    "Tax & Accounting Services",
    "Tools & Hardware",
    "Travel & Transportation"
]

export const isSiteAssociatedToSalesToken = (sitePath) => !sitePath.startsWith("/ISL") && !sitePath.startsWith("//")

export const STEP_DICTIONARY_TPL = {
    step0: {
        step: 0,
        icon: <i class="far fa-check-circle fa-1-5"></i>,
        title: <>Initial<br />Scan</>,
        stepTitle: ""
    },
    step1: {
        step: 1,
        icon: <i class="fab fa-google fa-1-5"></i>,
        title: <>Google<br />Analytics</>,
        stepTitle: "Get started for free. Add a plan later."
    },
    step2: {
        step: 2,
        icon: <i class="fas fa-hashtag fa-1-5"></i>,
        title: <>Social<br />Media</>,
        stepTitle: "Great, now let's claim social media."
    },
    step3: {
        step: 3,
        icon: <i class="fas fa-ad fa-1-5"></i>,
        title: <>Paid<br />Ads</>,
        stepTitle: "Next, do you run any paid ads?"
    },
    step4: {
        step: 4,
        icon: <i class="fas fa-search fa-1-5"></i>,
        title: <>Final<br />Review</>,
        stepTitle: "You're minutes away from your custom dashboard!"
    },
    step5: {
        step: 5,
        icon: <i class="fas fa-id-card-alt fa-1-5"></i>,
        title: <>Dashboard<br />Personalization</>,
        stepTitle: "Now, let's personalize your dashboard."
    },
    step6: {
        step: 6,
        icon: null,
        title: "",
        stepTitle: "Get started for free. Add a plan later."
    }
}

export const setInitialScanSite = (siteId) => {
    sessionStorage.setItem("initalScanSite", siteId)
}

export const ASSESSMENT_STATUS = {
	VERIFYING: "VERIFYING",
	VERIFIED: "VERIFIED",
	COMPLETE: "COMPLETE",
	PENDING: "PENDING",
	ERROR: "ERROR"
}